import { render, staticRenderFns } from "./AddNewDuration.vue?vue&type=template&id=5002bc83&scoped=true&"
import script from "./AddNewDuration.vue?vue&type=script&lang=ts&"
export * from "./AddNewDuration.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewDuration.vue?vue&type=style&index=0&id=5002bc83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5002bc83",
  null
  
)

component.options.__file = "AddNewDuration.vue"
export default component.exports